import { configureStore, combineReducers } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import userCodeReducer from './userCodeSlice'
import categoryReducer from './categorySlice'
import languageReducer from './languagesSlice'
import operatorReducer from './operatorSlice'
import socketRefetchReducer from './socketRefetchSlice'
import discrepancyReportSlice from './discrepancyReportSlice'
import networkErrorSlice from './networkErrorSlice'
import permissionErrorSlice from './permissionSlice'
import localeReducer from './localeSlice'
import checklistSavedReducer from './checkListValues'

const savedAuthState = localStorage.getItem('auth')
const initialState = savedAuthState
  ? { auth: JSON.parse(savedAuthState) }
  : undefined

const rootReducer = combineReducers({
  auth: authReducer,
  userCode: userCodeReducer,
  category: categoryReducer,
  languages: languageReducer,
  locale: localeReducer,
  operators: operatorReducer,
  socketRefetch: socketRefetchReducer,
  discrepancyReport: discrepancyReportSlice,
  networkError: networkErrorSlice,
  permissionError: permissionErrorSlice,
  checklistSaved: checklistSavedReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
